import { computed, unref, type MaybeRef } from 'vue';
import { useQuery } from '@tanstack/vue-query';
import type { AxiosResponse } from 'axios';
import type { hotOffers } from 'shared';

import { api } from '@/shared/api';
import { mapOffersResults } from '@/shared/lib';

type HotCountriesQueryParams = {
  origCityCode: MaybeRef<string>;
};

export function useHotCountriesQuery({
  origCityCode,
}: HotCountriesQueryParams) {
  const hotCountriesQuery = useQuery<
    AxiosResponse<hotOffers.HotOffersResponse>
  >({
    queryKey: ['hot-offers', 'countries', origCityCode],
    queryFn: () => {
      // @ts-expect-error TODO: infer proper types for hotOffers pfm module
      return api.hotOffers.countries({ departure: [unref(origCityCode)] });
    },
    staleTime: Infinity,
  });

  const hotCountries = computed(
    () =>
      hotCountriesQuery.data.value?.data.results.map(mapOffersResults) ?? [],
  );

  const isCountriesLoading = computed(() => hotCountriesQuery.isLoading.value);

  return {
    hotCountries,
    isCountriesLoading,
  };
}
